export const state = {
    isExporting: false
};

export const reducer = {
    startExporting: (state) => {
        if ('isExporting' in (state || {})) {
            state.isExporting = true;
        }
    },
    stopExporting: (state) => {
        if ('isExporting' in (state || {})) {
            state.isExporting = false;
        }
    }
};
